/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UtilityImageDTO } from "./UtilityImageDTO";
export type SubmitSecurityVerificationRequestDTO = {
  images: Array<UtilityImageDTO>;
  purpose: SubmitSecurityVerificationRequestDTO.purpose;
};
export namespace SubmitSecurityVerificationRequestDTO {
  export enum purpose {
    ONBOARDING = "ONBOARDING",
    TIER_UPGRADE = "TIER_UPGRADE",
    CORPORATE_DIRECTOR = "CORPORATE_DIRECTOR",
    PASSCODE_RESET = "PASSCODE_RESET",
    PASSCODE_CHANGE = "PASSCODE_CHANGE",
    PIN_RESET = "PIN_RESET",
    PIN_CHANGE = "PIN_CHANGE",
    UTILITY_CHECK = "UTILITY_CHECK",
  }
}
